/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgToolbarRefresh: React.FC<React.SVGAttributes<SVGElement>> = (
    props
) => (
    <svg viewBox="0 0 20 20" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M12.605 8.12l-.098-.006a.726.726 0 01-.628-.72l.007-.098a.726.726 0 01.72-.627l2.442-.001a6.048 6.048 0 10.535 5.658.726.726 0 011.34.558 7.5 7.5 0 11-.874-7.318v-2.34l.006-.099a.726.726 0 011.445.099v4.169l-.007.098a.725.725 0 01-.719.628h-4.169z"
            />
            <path d="M0 0h20v20H0z" />
        </g>
    </svg>
);
